<script>
    import { 
        linkWhatsappVendas, 
        textSite,
        
    } from '../store.js';

    import { afterUpdate, beforeUpdate }    from 'svelte';

    // Code
    export let classe   = "timeline-Widget--init";

    function customIframeTwitter(){        
        let iframeTwitter   = jQuery(".twitter-timeline");
        let htmlButtons     = jQuery('.template-buttons').val();

        iframeTwitter.contents().find("head").append(
            jQuery("<link/>", {
                rel: "stylesheet",
                href: "/assets/source/feedTwitter/css/feedTwitter.css",
                type: "text/css"
            }),
        );

        iframeTwitter.contents().find("body").append(
            jQuery("<script/>", {
                src: "/assets/source/feedTwitter/js/feedTwitter.js",
                type: "text/javascript"
            }),
        );

        iframeTwitter.contents().find(".timeline-Widget").addClass(classe);
        iframeTwitter.contents().find(".timeline-TweetList-tweet .timeline-Tweet-actions").html(htmlButtons);
        iframeTwitter.contents().find(".timeline-ShowMoreButton").html('Carregar mais oportunidades');

        jQuery('.oportunidades-imperdiveis').fadeIn()
    }

    beforeUpdate(() => { 
        jQuery("head").append(
            jQuery("<script>", {
                src: "https://platform.twitter.com/widgets.js",
                charset: "utf-8",
                type: "text/javascript"
            }),
        );
    });

    afterUpdate(() => { 
        setTimeout(customIframeTwitter, 2000);
    });
</script>	

<textarea class="template-buttons" style="display: none">
    <li class="timeline-buttons-custom">
        <a class="btn btn-contato" href="/contato" title="Entre em contato">
            Entre em Contato
        </a>
        <a class="btn btn-whatsapp" href="{$linkWhatsappVendas}" title="Fale pelo Whatsapp" target="_blank">
            Fale Pelo Whatsapp
        </a>
    </li>
</textarea> 

<div class="oportunidades-imperdiveis" style="display: none">
    <a class="twitter-timeline" href="https://twitter.com/ImobiliariaYara?ref_src=twsrc%5Etfw">
        Veja oportunidades imperdíveis no Twitter da {$textSite}
    </a> 
</div>